import { Link } from 'react-router-dom'
import classes from './ChatWidget.module.scss'
import { ChatPosLimitCompany, ChatPosLimits } from './types'
import { formatChatAmount } from './chatFormatters'
import { getProductCompanyBadge } from './productCompany'

const PAYMENT_PATH = '/myspecial/mypayments'

/** Marka adı/logosu SAP şirket kodundan çözülür; backend anlamlı bir ad gönderdiyse o kullanılır. */
function resolveCompany(company: ChatPosLimitCompany) {
  const badge = getProductCompanyBadge(Number(company.companyCode))
  const rawName = company.companyName?.trim()

  return {
    name: rawName || badge?.name || `Şirket ${company.companyCode}`,
    logoSrc: badge?.logoSrc ?? null,
  }
}

/**
 * Faz-43 (YAZGEL-14584): Avantaj POS / Fırsat POS tanımları. "Borcum nedir" kartıyla aynı şirket satırı
 * düzeni; her tanım için tür etiketi + tanım adı ve Limit / Harcanan / Kalan sütunları (TL). "Öde" butonu
 * yalnız backend `canPay` verdiyse çizilir ve ödeme sayfasına (/myspecial/mypayments) gider.
 */
export default function PosLimitsCard({ posLimits }: { posLimits: ChatPosLimits }) {
  if (posLimits.companies.length === 0) return null

  return (
    <div className={classes.debtCard} data-testid='pos-limits-card'>
      {posLimits.companies.map((company, i) => {
        const { name, logoSrc } = resolveCompany(company)

        return (
          <div key={`${company.companyCode}-${i}`} className={classes.debtRow}>
            <div className={classes.debtRowInfo}>
              <div className={classes.debtCompany}>
                {logoSrc && <img className={classes.debtCompanyLogo} src={logoSrc} alt='' />}
                <span>{name}</span>
              </div>
              {company.lines.map((line, j) => (
                <div key={`${line.type}-${j}`} className={classes.posLimitLine}>
                  <div className={classes.posLimitHead}>
                    <span className={classes.posLimitType}>{line.typeLabel}</span>
                    {line.name && <span className={classes.posLimitName}>{line.name}</span>}
                  </div>
                  {/* Tutarlar alt alta (etiket solda, tutar sağda): yan yana üç sütun dar panele sığmıyordu. */}
                  <dl className={classes.posLimitAmounts}>
                    <div className={classes.posLimitAmountRow}>
                      <dt className={classes.debtAmountCurrency}>Limit</dt>
                      <dd className={classes.debtAmountValue}>{formatChatAmount(line.limit)} TL</dd>
                    </div>
                    <div className={classes.posLimitAmountRow}>
                      <dt className={classes.debtAmountCurrency}>Harcanan</dt>
                      <dd className={classes.debtAmountValue}>{formatChatAmount(line.used)} TL</dd>
                    </div>
                    <div className={classes.posLimitAmountRow}>
                      <dt className={classes.debtAmountCurrency}>Kalan</dt>
                      <dd className={classes.debtAmountValue}>{formatChatAmount(line.remaining)} TL</dd>
                    </div>
                  </dl>
                </div>
              ))}
            </div>
            {posLimits.canPay && (
              <Link className={classes.debtPayBtn} to={PAYMENT_PATH} target='_blank' rel='noopener noreferrer'>
                Öde
              </Link>
            )}
          </div>
        )
      })}
    </div>
  )
}
